module.exports = __webpack_public_path__ + "static/media/results-dr.036b98bc.svg";